// src/data/items/glyphs.js
// Ichor and glyph item definitions for Glyphbinding skill

// Ichor types (gathered from ichor vats)
export const ESSENCE = [
    { id: 'arcane_residue', name: 'Arcane Residue', icon: '💧', color: '#E8E8E8', category: 'ichor', type: 'resource', value: 25 },
    { id: 'refined_arcane_ichor', name: 'Refined Arcane Ichor', icon: '💜', color: '#9B59B6', category: 'ichor', type: 'resource', value: 110 },
    { id: 'purified_arcane_core', name: 'Purified Arcane Core', icon: '💎', color: '#00CED1', category: 'ichor', type: 'resource', value: 260 },
];

// Glyph items (crafted from ichor) - 12 glyphs total
// All glyphs serve dual purpose: combat spells AND glyph cores for staffs
// Value curve: base elementals are cheap (free daily, common mob drops), higher tiers scale smoothly
export const GLYPHS = [
    // Elemental glyphs - Arcane Residue (levels 1-14)
    // Low value: given free daily, drop frequently from mobs, used in all magic builds
    { id: 'storm_glyph', name: 'Storm Glyph', icon: '⚡', color: '#87CEEB', category: 'glyph', type: 'resource', value: 10,
      sprite: { sheet: 'assets/icons/glyphbinding/storm_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'frost_glyph', name: 'Frost Glyph', icon: '❄️', color: '#1E90FF', category: 'glyph', type: 'resource', value: 10,
      sprite: { sheet: 'assets/icons/glyphbinding/frost_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'stone_glyph', name: 'Stone Glyph', icon: '🪨', color: '#8B4513', category: 'glyph', type: 'resource', value: 10,
      sprite: { sheet: 'assets/icons/glyphbinding/stone_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'flame_glyph', name: 'Flame Glyph', icon: '🔥', color: '#FF4500', category: 'glyph', type: 'resource', value: 10,
      sprite: { sheet: 'assets/icons/glyphbinding/flame_glyph.png', x: 0, y: 0, width: 64, height: 64 } },

    // Aspect glyph - Arcane Residue (level 25)
    { id: 'vigor_glyph', name: 'Vigor Glyph', icon: '💪', color: '#4169E1', category: 'glyph', type: 'resource', value: 100,
      sprite: { sheet: 'assets/icons/glyphbinding/vigor_glyph.png', x: 0, y: 0, width: 64, height: 64 } },

    // Primal glyphs - Refined Arcane Ichor (levels 35-44)
    { id: 'verdant_glyph', name: 'Verdant Glyph', icon: '🌿', color: '#228B22', category: 'glyph', type: 'resource', value: 175,
      sprite: { sheet: 'assets/icons/glyphbinding/verdant_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'entropy_glyph', name: 'Entropy Glyph', icon: '🌀', color: '#FF6347', category: 'glyph', type: 'resource', value: 225,
      sprite: { sheet: 'assets/icons/glyphbinding/entropy_glyph.png', x: 0, y: 0, width: 64, height: 64 } },

    // Cosmic glyphs - Refined Arcane Ichor (levels 55-65)
    { id: 'void_glyph', name: 'Void Glyph', icon: '🌑', color: '#9932CC', category: 'glyph', type: 'resource', value: 325,
      sprite: { sheet: 'assets/icons/glyphbinding/void_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'binding_glyph', name: 'Binding Glyph', icon: '⛓️', color: '#FFD700', category: 'glyph', type: 'resource', value: 425,
      sprite: { sheet: 'assets/icons/glyphbinding/binding_glyph.png', x: 0, y: 0, width: 64, height: 64 } },

    // Forbidden glyphs - Purified Arcane Core (levels 75-95)
    { id: 'doom_glyph', name: 'Doom Glyph', icon: '💀', color: '#2F4F4F', category: 'glyph', type: 'resource', value: 575,
      sprite: { sheet: 'assets/icons/glyphbinding/doom_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'sanguine_glyph', name: 'Sanguine Glyph', icon: '🩸', color: '#8B0000', category: 'glyph', type: 'resource', value: 750,
      sprite: { sheet: 'assets/icons/glyphbinding/sanguine_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
    { id: 'spirit_glyph', name: 'Spirit Glyph', icon: '👻', color: '#E6E6FA', category: 'glyph', type: 'resource', value: 950,
      sprite: { sheet: 'assets/icons/glyphbinding/spirit_glyph.png', x: 0, y: 0, width: 64, height: 64 } },
];
